import { call, put, select } from 'redux-saga/effects';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { SessionSiteSelectors } from '../../app/selectors/SessionInfoSelectors';
import { ServiceLocator } from '../../app/ServiceLocator';
import { Messages } from '../../codegen/Localize';
import { FlowDetailInfo } from '../../ts/models/FlowInfo';
import { ContentActions } from '../../ts/services/ContentActions';
import { EditFlowReduxAction } from '../actions/EditFlowReduxAction';
import { getFlowDetailInfo } from '../FlowsSagaHelpers';

export function* handleEditFlow(action: EditFlowReduxAction) {
  try {
    const siteUrlName: string = yield select(SessionSiteSelectors.siteUrlName);
    const flowDetailInfo: FlowDetailInfo = yield call(getFlowDetailInfo, action.flow.id);
    ServiceLocator.get<ContentActions>('ContentActions').editFlow(siteUrlName, flowDetailInfo.name, flowDetailInfo.luid);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
